import { Cascader } from 'antd'
import { areaList } from '@vant/area-data'

interface CityOption {
  label: string
  value: string
  children?: CityOption[]
}

const cityEntries = Object.entries(areaList.city_list)

const provinceCityOptions: CityOption[] = Object.entries(areaList.province_list).map(([provinceCode, provinceName]) => ({
  label: provinceName,
  value: provinceName,
  children: cityEntries
    .filter(([cityCode]) => cityCode.slice(0, 2) === provinceCode.slice(0, 2))
    .map(([, cityName]) => ({ label: cityName, value: cityName })),
}))

function normalizeAreaName(value: string) {
  return value.replace(/(?:特别行政区|壮族自治区|回族自治区|维吾尔自治区|自治区|省|市)$/u, '')
}

function findSelectedPath(city?: string): string[] | undefined {
  const value = city?.trim()
  if (!value) return undefined

  const savedPath = value.split(/\s*\/\s*/u)
  if (savedPath.length === 2) {
    const province = provinceCityOptions.find((option) => option.value === savedPath[0])
    if (province?.children?.some((option) => option.value === savedPath[1])) return savedPath
  }

  const normalizedValue = normalizeAreaName(value)
  for (const province of provinceCityOptions) {
    const cityOption = province.children?.find((option) =>
      option.value === value || normalizeAreaName(option.value) === normalizedValue)
    if (cityOption) return [province.value, cityOption.value]
  }

  return [value]
}

function formatSelectedCity(path: Array<string | number>) {
  const values = path.map(String)
  if (!values.length) return undefined
  return values[values.length - 1]
}

export function ChinaCityCascader({ value, onChange }: { value?: string; onChange: (value?: string) => void }) {
  const selectedPath = findSelectedPath(value)
  const isLegacyValue = selectedPath?.length === 1
  const options = isLegacyValue
    ? [{ label: `${selectedPath[0]}（原值）`, value: selectedPath[0] }, ...provinceCityOptions]
    : provinceCityOptions

  return <Cascader
    allowClear
    changeOnSelect={false}
    className="mt-2 w-full"
    displayRender={(labels) => labels.join(' / ')}
    expandTrigger="hover"
    options={options}
    placeholder="请选择省/直辖市和城市"
    showSearch={{
      filter: (inputValue, path) => path.some((option) => option.label.toLowerCase().includes(inputValue.toLowerCase())),
    }}
    value={selectedPath}
    onChange={(path) => onChange(formatSelectedCity(path))}
  />
}
